const fragmentShader = `uniform vec3 uBoxColorList[MAX_BOX_LIST];
uniform bool bFixedIntensity;
uniform bool bIsMainView;
uniform bool bPcdPointColorVisible;
uniform bool bVisible; // FST Background PCD visible

varying float vIntensityFloat;
varying float vBoxIndexFloat;
varying float vIsExtendedPoint;
varying float vIsExtendedEqualZAxis;

void main() {
  float intensity = bFixedIntensity ? 1.0 : vIntensityFloat;

  if (vIsExtendedEqualZAxis < 1.0 && vIsExtendedPoint > 0.5) {
    // 확장된 영역이면서 Z축이 같지 않은 경우의 포인트인 경우 흰색으로 표시
    gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);  // 흰색
    return;
  } else if (vIsExtendedEqualZAxis == 1.0) {
    // Z축이 같은 포인트면 하늘색으로 표시
    gl_FragColor = vec4(0.24, 0.47, 1.0, 1.0);  // 하늘색
    return;
  }

  if (bVisible == false) {
    if (vBoxIndexFloat >= 0.0) {
      int boxIndex = int(vBoxIndexFloat + 0.5);
      if (boxIndex >= 0 && boxIndex < MAX_BOX_LIST) {
        vec3 finalColor = bPcdPointColorVisible
          ? uBoxColorList[boxIndex]
          : vec3(1.0, 1.0, 1.0);
        vec3 color = clamp(finalColor * intensity * 2.0, 0.0, 1.0);
        gl_FragColor = vec4(color, 1.0);
      } else {
        discard;
      }
    } else {
      discard;
    }
  } else {
    vec3 finalColor = vec3(1.0, 1.0, 1.0) * intensity * 2.0;
    
    if (bPcdPointColorVisible && vBoxIndexFloat >= 0.0) {
      int boxIndex = int(vBoxIndexFloat + 0.5);
      if (boxIndex >= 0 && boxIndex < MAX_BOX_LIST) {
        finalColor = uBoxColorList[boxIndex] * intensity * 2.0;
      }
    }
    
    vec3 color = clamp(finalColor, 0.0, 1.0);
    gl_FragColor = vec4(color, 1.0);
  }
}`;

export default fragmentShader;
